// extracted by mini-css-extract-plugin
module.exports = {"main":"recent_main__slNj_","leftCon":"recent_leftCon__LHYqY","arrow":"recent_arrow__NPrbD","rightCon":"recent_rightCon__a7zO7","etfTip":"recent_etfTip__TOI7K"};